<div class="container-fluid cw-background manage-partner-company manage-view">
  <mat-card class="mat-elevation-z8 my-3">
    <div class="text-left go-back d-block">
      <button (click)="onGoBack()" disableRipple mat-button class="delete-user p-0">
        <mat-icon matPreffix>arrow_back_ios</mat-icon>
        Go Back
      </button>
      <h6 class="card-title-page mb-4">Edit Partner:</h6>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
        <app-dynamic-form
          *ngIf="questions"
          [questions]="questions"
          [disabled]="!isEdit"
          (formSubmit)="onUpdatePartner($event)"
        >
        </app-dynamic-form>
        <button
          *ngIf="currentUser.hasRight(['admin', 'manager'])"
          (click)="onToggleManagePartner()"
          class="edit"
          color="primary"
          mat-icon-button
        >
          <mat-icon>create</mat-icon><span class="mat-h3"> Edit</span>
        </button>
      </div>
    </div>
    <div class="row d-flex delete-btn">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
        <button *ngIf="currentUser.hasRight(['admin']) && !isEdit" disableRipple mat-button (click)="onDeletePartner()">
          <mat-icon matPreffix>delete</mat-icon>
          Delete Partner
        </button>
      </div>
    </div>
    <div class="container-fluid cw-background">
      <div class="row">
        <div class="col-12">
          <mat-tab-group [@.disabled]="true" (selectedTabChange)="onTabChange()">
            <mat-tab label="Companies">
              <app-data-table
                *ngIf="companiesTableConfig"
                [config]="companiesTableConfig"
                (getData)="getCompanies($event)"
                (updateData)="companyTableService.update($event)"
              ></app-data-table>
            </mat-tab>
            <mat-tab label="Users">
              <app-data-table
                *ngIf="usersTableConfig"
                [config]="usersTableConfig"
                (getData)="getUsers($event)"
                (updateData)="userTableService.update($event)"
              ></app-data-table>
            </mat-tab>
            <mat-tab *ngIf="canUpdateCWRep()" label="CW Rep.">
              <app-data-table
                *ngIf="cwRepsTableConfig"
                [config]="cwRepsTableConfig"
                (getData)="getCWReps($event)"
              ></app-data-table>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </mat-card>
</div>
